// Produto ativo gravado no device (localStorage.produtoAtual). Módulo mínimo,
// sem React nem imports do Hub, para quem precisa do valor fora do provider e
// do Router (PO1-3508: o hook do chat do Autopilot manda o produto no contexto).
// O provider em hooks/activeProduct.js usa estas mesmas funções.
export const STORAGE_KEY = "produtoAtual";

export function lerProdutoAtual() {
  if (typeof window === "undefined") return null;
  try {
    return window.localStorage.getItem(STORAGE_KEY) || null;
  } catch (e) {
    return null;
  }
}

export function gravarProdutoAtual(code) {
  if (typeof window === "undefined") return;
  try {
    if (code) window.localStorage.setItem(STORAGE_KEY, code);
    else window.localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // Storage bloqueado (modo privado): o produto vale só nesta sessão.
  }
}
